module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 1c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7m0-1C3.588 0 0 3.588 0 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8z\"/><path d=\"M9.333 11.667c0 .458-.238 1-.762 1H7.429c-.523 0-.762-.542-.762-1V8.333c0-.458.238-1 .762-1h1.143c.523 0 .762.542.762 1v3.334z\"/><circle cx=\"8\" cy=\"4.667\" r=\"1.333\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/info.svg
// module id = 62
// module chunks = 0